export const REGISTRATION_CODE_EXPIRATION_DAYS = 7;
export const MINIMUM_PASSWORD_LENGTH = 12;
